export default __webpack_public_path__ + "static/char-s-12-en-9a62e029ddc4171262586c11bd52ce03.webp";